var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-body" },
    [
      _c("page-banner", _vm._b({}, "page-banner", _vm.page.banner, false)),
      _c(
        "section",
        { staticClass: "page-section coop-section" },
        [
          _c(
            "page-limiter",
            [
              _vm.crumbs && _vm.crumbs.length
                ? _c("breadcrumbs", { attrs: { crumbs: _vm.crumbs } })
                : _vm._e(),
              _c("h2", { staticClass: "page-section__title" }, [
                _vm._v(_vm._s(_vm.page.title))
              ]),
              _c("div", { staticClass: "page-section__caption" }, [
                _c("p", [_vm._v(_vm._s(_vm.page.caption))]),
                _vm.showSteps
                  ? _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "scroll-to",
                            rawName: "v-scroll-to",
                            value: { target: "#join" },
                            expression: "{target: '#join'}"
                          },
                          {
                            name: "scroll-reveal",
                            rawName: "v-scroll-reveal",
                            value: { delay: 800 },
                            expression: "{delay: 800}"
                          }
                        ],
                        staticClass: "btn btn--primary btn--has-arrow",
                        attrs: { tag: "link", href: "#join" }
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(_vm.page.toJoin) +
                            "\n\t\t\t\t\t"
                        ),
                        _c("icon-arrow", { staticClass: "btn-icon" })
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _vm.page.partnerFeatures && _vm.page.partnerFeatures.length
                ? _c(
                    "ul",
                    { staticClass: "partner-features" },
                    _vm._l(_vm.page.partnerFeatures, function(item, index) {
                      return _c(
                        "li",
                        {
                          directives: [
                            {
                              name: "scroll-reveal",
                              rawName: "v-scroll-reveal",
                              value: { delay: 220 + index * 60 },
                              expression: "{delay: 220 + index * 60}"
                            }
                          ],
                          staticClass: "partner-features__item"
                        },
                        [
                          item.image
                            ? _c("img", {
                                staticClass: "partner-features__item-icon",
                                attrs: {
                                  width: "110",
                                  height: "90",
                                  src: item.image,
                                  alt: ""
                                }
                              })
                            : _vm._e(),
                          _c(
                            "div",
                            { staticClass: "partner-features__item-title" },
                            [_vm._v(_vm._s(item.title))]
                          ),
                          _c(
                            "p",
                            { staticClass: "partner-features__item-caption" },
                            [_vm._v(_vm._s(item.caption))]
                          )
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm.page.geoSection
        ? _c(
            "section",
            { staticClass: "page-section coop-section geo-section" },
            [
              _c("page-limiter", [
                _c("div", { staticClass: "geo-section__row" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        { name: "scroll-reveal", rawName: "v-scroll-reveal" }
                      ],
                      staticClass: "geo-section__text"
                    },
                    [
                      _c("h2", { staticClass: "geo-section__title" }, [
                        _vm._v(_vm._s(_vm.page.geoSection.title))
                      ]),
                      _c("p", { staticClass: "geo-section__caption" }, [
                        _vm._v(_vm._s(_vm.page.geoSection.caption))
                      ])
                    ]
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "scroll-reveal",
                          rawName: "v-scroll-reveal",
                          value: { delay: 400 },
                          expression: "{delay: 400}"
                        }
                      ],
                      staticClass: "geo-section__map"
                    },
                    [
                      _c("img", {
                        staticClass: "geo-section__image",
                        attrs: {
                          width: "0",
                          height: "0",
                          src: require("static/images/map.svg"),
                          alt: ""
                        }
                      })
                    ]
                  )
                ])
              ])
            ],
            1
          )
        : _vm._e(),
      _vm.page.productMetaSection
        ? _c(
            "section",
            { staticClass: "page-section coop-section product-meta-section" },
            [
              _c("page-limiter", [
                _c(
                  "h2",
                  {
                    staticClass: "page-section__title page-section__title--sm"
                  },
                  [_vm._v(_vm._s(_vm.page.productMetaSection.title))]
                ),
                _vm.productMeta && _vm.productMeta.length
                  ? _c(
                      "ul",
                      {
                        directives: [
                          {
                            name: "scroll-reveal",
                            rawName: "v-scroll-reveal",
                            value: {
                              mobile: true,
                              duration: 0,
                              delay: 400,
                              afterReveal: _vm.animateCounter
                            },
                            expression:
                              "{mobile: true, duration: 0, delay: 400, afterReveal: animateCounter}"
                          }
                        ],
                        staticClass: "product-meta"
                      },
                      _vm._l(_vm.productMeta, function(item, index) {
                        return _c("li", { staticClass: "product-meta__item" }, [
                          _c(
                            "div",
                            { staticClass: "product-meta__item-title" },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(item.title) +
                                  "\n\t\t\t\t\t\t"
                              ),
                              _c(
                                "span",
                                {
                                  directives: [
                                    { name: "odometer", rawName: "v-odometer" }
                                  ],
                                  ref: "counter",
                                  refInFor: true,
                                  staticClass: "product-meta__item-title-value",
                                  attrs: { "data-value": item.title }
                                },
                                [_vm._v("0")]
                              )
                            ]
                          ),
                          _c(
                            "p",
                            { staticClass: "product-meta__item-caption" },
                            [_vm._v(_vm._s(item.caption))]
                          )
                        ])
                      }),
                      0
                    )
                  : _vm._e()
              ])
            ],
            1
          )
        : _vm._e(),
      _vm.page.productFeaturesSection
        ? _c(
            "section",
            {
              staticClass: "page-section coop-section product-features-section"
            },
            [
              _c("page-limiter", [
                _c(
                  "h2",
                  {
                    staticClass: "page-section__title page-section__title--sm"
                  },
                  [_vm._v(_vm._s(_vm.page.productFeaturesSection.title))]
                ),
                _vm.productFeatures && _vm.productFeatures.length
                  ? _c(
                      "ul",
                      { staticClass: "partner-features product-features" },
                      _vm._l(_vm.productFeatures, function(item, index) {
                        return _c(
                          "li",
                          {
                            directives: [
                              {
                                name: "scroll-reveal",
                                rawName: "v-scroll-reveal",
                                value: { delay: 220 + index * 60 },
                                expression: "{delay: 220 + index * 60}"
                              }
                            ],
                            staticClass: "partner-features__item"
                          },
                          [
                            item.image
                              ? _c("img", {
                                  staticClass: "partner-features__item-icon",
                                  attrs: {
                                    width: "110",
                                    height: "90",
                                    src: item.image,
                                    alt: ""
                                  }
                                })
                              : _vm._e(),
                            _c(
                              "p",
                              { staticClass: "partner-features__item-caption" },
                              [_vm._v(_vm._s(item.caption))]
                            )
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e()
              ])
            ],
            1
          )
        : _vm._e(),
      _vm.page.offerSection
        ? _c(
            "section",
            { staticClass: "page-section coop-section offer-section" },
            [
              _c("page-limiter", [
                _c(
                  "h2",
                  {
                    staticClass: "page-section__title page-section__title--sm"
                  },
                  [_vm._v(_vm._s(_vm.page.offerSection.title))]
                ),
                _vm.offerFeatures && _vm.offerFeatures.length
                  ? _c(
                      "ul",
                      { staticClass: "offer-features" },
                      _vm._l(_vm.offerFeatures, function(item, index) {
                        return _c(
                          "li",
                          { staticClass: "offer-features__item" },
                          [
                            _c("div", { staticClass: "offer-features__icon" }, [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "40",
                                    height: "40",
                                    viewBox: "0 0 40 40"
                                  }
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d:
                                        "M40 20c0-1.6-1.1-3-2.5-3.5.4-.4.8-.9 1-1.5.4-1 .3-2.2-.3-3.2-.7-1.2-2.1-1.9-3.4-1.8.3-.5.4-1.1.4-1.7 0-1-.5-2-1.3-2.7-1.1-.9-2.7-1.1-4-.5 0-.7-.1-1.4-.5-2-.5-.9-1.3-1.5-2.2-1.7-1.4-.4-2.8.1-3.8 1.1-.2-.6-.5-1.1-1-1.5-.8-.7-1.8-1-2.8-.9-1.5.2-2.6 1.2-3.1 2.5-.4-.4-.9-.8-1.5-1-1-.4-2.2-.3-3.2.3-1.2.7-1.9 2-1.8 3.4-.5-.4-1.1-.5-1.7-.5-1 0-2 .5-2.7 1.3-.9 1.1-1.1 2.7-.5 4-.7 0-1.4.1-2 .5-.9.5-1.5 1.3-1.7 2.2-.4 1.4.1 2.8 1.1 3.8-.6.2-1.1.5-1.5 1-.7.8-1 1.8-.9 2.8.2 1.5 1.2 2.6 2.5 3.1-.4.4-.8.9-1 1.5-.4 1-.3 2.2.3 3.2.7 1.2 2.1 1.9 3.4 1.8-.3.5-.4 1.1-.4 1.7 0 1 .5 2 1.3 2.7 1.1.9 2.7 1.1 4 .5 0 .7.1 1.4.5 2 .5.9 1.3 1.5 2.2 1.7 1.4.4 2.8-.1 3.8-1.1.2.6.5 1.1 1 1.5.8.7 1.8 1 2.8.9 1.5-.2 2.6-1.2 3.1-2.5.4.4.9.8 1.5 1 1 .4 2.2.3 3.2-.3 1.2-.7 1.9-2 1.8-3.4.5.3 1.1.4 1.7.4 1 0 2-.5 2.7-1.3.9-1.1 1.1-2.7.5-4 .7 0 1.4-.1 2-.5.9-.5 1.5-1.3 1.7-2.2.4-1.4-.1-2.8-1.1-3.8C38.9 23 40 21.6 40 20z",
                                      fill: "#00b100"
                                    }
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d:
                                        "M22.4 22.8l-3.1 3.1c-.4.4-.8.7-1.3.8-.4.1-.9 0-1.3-.2-.2-.1-.4-.3-.6-.5-.3-.3-.6-.5-.8-.8-.5-.5-1.1-1-1.6-1.5s-1.1-1-1.6-1.5c-.4-.4-.9-.7-1.1-1.2-.3-.8-.1-1.9.7-2.4.8-.6 1.9-.4 2.6.3 1 .9 2 1.9 3 2.8.2.2.5.2.7 0l6.2-6.2 1.6-1.6c.4-.4.8-.6 1.3-.7.9-.2 1.8.5 2.1 1.3.2.7.1 1.5-.5 2-2.1 2.2-4.2 4.2-6.3 6.3z",
                                      fill: "#fff"
                                    }
                                  })
                                ]
                              )
                            ]),
                            _c(
                              "p",
                              { staticClass: "offer-features__item-caption" },
                              [_vm._v(_vm._s(item))]
                            )
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e()
              ])
            ],
            1
          )
        : _vm._e(),
      _c("page-content", { attrs: { page: _vm.page } }),
      _vm.showSteps
        ? _c(
            "section",
            {
              staticClass: "page-section coop-section join-section",
              attrs: { id: "join" }
            },
            [
              _vm.page.joinSection
                ? _c("page-limiter", [
                    _c("h2", { staticClass: "page-section__title" }, [
                      _vm._v(_vm._s(_vm.page.joinSection.title))
                    ]),
                    _vm.page.joinSection.steps &&
                    _vm.page.joinSection.steps.length
                      ? _c(
                          "ul",
                          { staticClass: "join-steps" },
                          _vm._l(_vm.page.joinSection.steps, function(
                            item,
                            index
                          ) {
                            return _c(
                              "li",
                              { staticClass: "join-steps__item" },
                              [
                                _c(
                                  "div",
                                  {
                                    class: [
                                      "join-step-tile",
                                      {
                                        "join-step-tile--inactive":
                                          item.inactive
                                      }
                                    ]
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "join-step-tile__index" },
                                      [_vm._v(_vm._s(item.index))]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "join-step-tile__title" },
                                      [_vm._v(_vm._s(item.title))]
                                    ),
                                    item.inactive
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "join-step-tile__note"
                                          },
                                          [_vm._v(_vm._s(item.inactive))]
                                        )
                                      : _c(
                                          "btn",
                                          {
                                            staticClass:
                                              "btn btn--primary btn--has-arrow join-step-tile__action",
                                            attrs: {
                                              tag: "link",
                                              link:
                                                _vm.$route.path +
                                                "?" +
                                                item.action.link
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t" +
                                                _vm._s(item.action.title) +
                                                "\n\t\t\t\t\t\t\t"
                                            ),
                                            _c("icon-arrow", {
                                              staticClass: "btn-icon"
                                            })
                                          ],
                                          1
                                        )
                                  ],
                                  1
                                )
                              ]
                            )
                          }),
                          0
                        )
                      : _vm._e()
                  ])
                : _vm._e(),
              _c(
                "page-overlay",
                {
                  attrs: {
                    show: _vm.joinIsShow,
                    width: 588,
                    "auto-height": true
                  },
                  on: {
                    close: function($event) {
                      return _vm.$router.push(_vm.$route.path)
                    }
                  }
                },
                [
                  _c("h3", { staticClass: "page-overlay-title" }, [
                    _vm._v(_vm._s(_vm.feedback.title))
                  ]),
                  _c("feedback-form", {
                    attrs: {
                      content: _vm.feedback,
                      clear: _vm.joinFormIsClear,
                      action: "/form/join",
                      ya_metrica_goal: "partners_request"
                    }
                  })
                ],
                1
              ),
              _c(
                "page-overlay",
                {
                  attrs: {
                    show: _vm.docsIsShow,
                    width: 774,
                    "auto-height": false
                  },
                  on: {
                    close: function($event) {
                      return _vm.$router.push(_vm.$route.path)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "page-overlay-post" }, [
                    _c("h3", { staticClass: "page-overlay-post__title" }, [
                      _vm._v(_vm._s(_vm.page.docsInfo.title))
                    ]),
                    _c("div", { staticClass: "docs-tabs" }, [
                      _c(
                        "div",
                        { staticClass: "docs-tabs__head" },
                        _vm._l(_vm.page.docsInfo.tabs, function(tab, index) {
                          return _c(
                            "btn",
                            {
                              key: "tab-" + index,
                              class: [
                                "docs-tabs__title",
                                "btn",
                                _vm.activeDocsTabIndex === index
                                  ? "btn--primary"
                                  : "btn--outline"
                              ],
                              attrs: { tag: "control" },
                              nativeOn: {
                                click: function($event) {
                                  return _vm.setDocsTab(index)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t" +
                                  _vm._s(tab.title) +
                                  "\t\n\t\t\t\t\t\t"
                              )
                            ]
                          )
                        }),
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "docs-tabs__body" },
                        _vm._l(_vm.page.docsInfo.tabs, function(tab, index) {
                          return _c("div", {
                            class: [
                              "docs-tabs__tab",
                              {
                                "docs-tabs__tab--active":
                                  _vm.activeDocsTabIndex === index
                              }
                            ],
                            domProps: { innerHTML: _vm._s(tab.content) }
                          })
                        }),
                        0
                      )
                    ]),
                    _c("div", { staticClass: "docs-note" }, [
                      _c(
                        "svg",
                        {
                          staticClass: "docs-note__icon",
                          attrs: {
                            width: "24",
                            height: "30",
                            viewBox: "0 0 24 30"
                          }
                        },
                        [
                          _c("path", {
                            attrs: {
                              d:
                                "M23 30H1c-.5 0-1-.4-1-1V1c0-.5.4-1 1-1h22c.5 0 1 .4 1 1v28c0 .6-.4 1-1 1zM2 28.1h20V2H2v26.1z"
                            }
                          }),
                          _c("path", {
                            attrs: {
                              d:
                                "M16.9 9.4H7.1c-.5 0-1-.4-1-1s.4-1 1-1H17c.5 0 1 .4 1 1s-.5 1-1.1 1zM12.3 22.7H7.1c-.5 0-1-.4-1-1 0-.5.4-1 1-1h5.2c.5 0 1 .4 1 1s-.4 1-1 1zM16.9 16.1H7.1c-.5 0-1-.4-1-1 0-.5.4-1 1-1H17c.5 0 1 .4 1 1-.1.5-.5 1-1.1 1z"
                            }
                          })
                        ]
                      ),
                      _vm._v(
                        "\n\n\t\t\t\t\t" +
                          _vm._s(_vm.page.docsInfo.note) +
                          "\n\t\t\t\t"
                      )
                    ])
                  ])
                ]
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-61cf4d56", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61cf4d56","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/pages/PageCooperation.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-61cf4d56","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/pages/PageCooperation.vue
// module chunks = 0